<template>
  <div :class="jel_getClassObject(content)" class="cursor-pointer" @click.capture="gaPreventClick">
    <b-link
      v-bind="jel_getLienBinding(content.lien)"
      class="bouton-image position-relative d-flex align-items-center overflow-hidden"
    >
      <MediaImageFocalPoint
        :content="{
          formatRatio: '16x9',
          image: content.image,
        }"
        class="flex-fill justify-content-center"
      >
      </MediaImageFocalPoint>
      <span class="position-absolute px-2 texte-bouton">{{ content.libBouton }}</span>
    </b-link>
  </div>
</template>

<script>
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';

import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

export default {
  name: 'BoutonImage',
  components: { MediaImageFocalPoint },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      refRedirection: this._uid,
    };
  },
  methods: {
    gaPreventClick(event = null) {
      // Récupère la position du Bouton Image
      const listeBtnImage = document.getElementsByClassName('bouton-image');
      let position = null;
      for (let i = 0; i < listeBtnImage.length; i++) {
        if (listeBtnImage[i].innerText === this.content.libBouton) position = i + 1;
      }
      // Ajout datalayer pour ajouter Event click sur bouton Image vers Google Analytics
      gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
        event: 'ga-bc-click',
        categorie: 'BC - Bouton de catégorie',
        emplacement: this.jel_gaGetEmplacement(),
        libelle: this.content.libBouton,
        position,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.texte-bouton {
  color: #fff;
  font-family: graphik_medium;
  line-height: 1.063rem;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 3px 3px 3px $noir-casino;
  z-index: 1;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.bouton-image {
  border-radius: 8px;
  > div {
    max-height: 3rem;
  }
  &:after {
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: transparent linear-gradient(255deg, #010e2a00 0%, #010e2a 100%) 0% 0% no-repeat;
    transition: filter 0.3s;
  }
  &:hover:after {
    filter: brightness(0.5);
  }
  &:focus-visible {
    outline: solid 3px $couleur-primaire-bouton-theme-clair;
  }
}

div::v-deep img {
  object-fit: cover;
  width: 100%;
}
</style>
